import React from 'react';

import InfoVerifyView from '../../views/InfoVerify/index.jsx';



function InfoVerify() {
  return (

        <InfoVerifyView />

   
  );
}

export default InfoVerify;
